import classNames from "classnames";

export function LiveGameWarships({ warships, leftSide }) {
    return (
        <div className={classNames("flex items-center justify-center liveGameOverlay__warships", leftSide ? "flex-row" : "flex-row-reverse")}>
            {warships > 0 && (
                <>
                    <img className="w-6 h-6 mt-[0px]" src="/liveGameIcons/warship.png" alt="" />
                    <p className="text-[#b1b1b1] text-xl">{warships}</p>
                    <p className="text-[#b1b1b1] text-xl -mt-1"></p>
                </>
            )}
        </div>
    )
}